import { DayType } from 'app/constants/dayType'

export const getDayType = (type) => {
  let dayType = DayType.NONE

  switch (type) {
    case 1:
      dayType = DayType.P
      break
    case 2:
      dayType = DayType.W
      break
    case 3:
      dayType = DayType.Ws
      break
    case 4:
      dayType = DayType.Wn
      break
    case 5:
      dayType = DayType.Wx
      break
    case 6:
      dayType = DayType.U
      break
    case 7:
      dayType = DayType.C
      break
    case 8:
      dayType = DayType.Uo
      break
    case 9:
      dayType = DayType.Nn
      break
    case 10:
      dayType = DayType.Bw
      break
    case 11:
      dayType = DayType.M
      break
    case 12:
      dayType = DayType.Uoj
      break
    case 13:
      dayType = DayType.D
      break
    case 14:
      dayType = DayType.Ps
      break
    case 15:
      dayType = DayType.Pw
      break
    case 16:
      dayType = DayType.Xw
      break
    case 17:
      dayType = DayType.Xb
      break
    case 18:
      dayType = DayType.Uz
      break
    case 19:
      dayType = DayType.U2
      break
    case 20:
      dayType = DayType.Cn
      break
    case 21:
      dayType = DayType.Cb
      break
    case 22:
      dayType = DayType.Z
      break
    case 23:
      dayType = DayType.Zb
      break
    case 24:
      dayType = DayType.Zs
      break
    case 25:
      dayType = DayType.Zw
      break
    case 26:
      dayType = DayType.Zn
      break
    case 27:
      dayType = DayType.Od
      break
    case 28:
      dayType = DayType.Or
      break
    case 29:
      dayType = DayType.Np
      break
    case 30:
      dayType = DayType.Nu
      break
    case 31:
      dayType = DayType.Ui
      break
    case 32:
      dayType = DayType.Un
      break
    case 33:
      dayType = DayType.Ur
      break
    case 34:
      dayType = DayType.Ux
      break
    case 35:
      dayType = DayType.Us
      break
    case 36:
      dayType = DayType.Um
      break
    case 37:
      dayType = DayType.Uf
      break
    case 38:
      dayType = DayType.Bp
      break
    case 39:
      dayType = DayType.Rc
      break
    case 40:
      dayType = DayType.Rw
      break
    case 41:
      dayType = DayType.Rb
      break
    case 42:
      dayType = DayType.Oo
      break
    case 43:
      dayType = DayType.D1
      break
    case 44:
      dayType = DayType.D2
      break
    case 45:
      dayType = DayType.Sw
      break
    case 46:
      dayType = DayType.Prz
      break
    case 47:
      dayType = DayType.NoContract
      break
    case 48:
      dayType = DayType.Wo
      break
    case 49:
      dayType = DayType.WoC
      break
    case 50:
      dayType = DayType.WoCn
      break
    case 51:
      dayType = DayType.WoCb
      break
    case 52:
      dayType = DayType.WoZ
      break
    case 53:
      dayType = DayType.WoZb
      break
    case 54:
      dayType = DayType.WoZs
      break
    case 55:
      dayType = DayType.WoZw
      break
    case 56:
      dayType = DayType.WoZn
      break
    case 57:
      dayType = DayType.WoOd
      break
    case 58:
      dayType = DayType.WoOr
      break
    case 59:
      dayType = DayType.WoRc
      break
    case 60:
      dayType = DayType.WoRw
      break
    case 61:
      dayType = DayType.WoRb
      break
    case 62:
      dayType = DayType.WoOo
      break
    case 63:
      dayType = DayType.WoM
      break
    case 64:
      dayType = DayType.WoUoj
      break
    case 65:
      dayType = DayType.Xd
      break
  }

  return dayType
}
